module.exports = __webpack_public_path__ + "img/ipad-frame-8.a12a1c7d.png";